// extracted by mini-css-extract-plugin
module.exports = {"logo":"FormLogo_logo__V6SG3"};